import Image from '@tiptap/extension-image';

export const ImageResize = Image.extend({
  addOptions() {
    return {
      inline: true,
      allowBase64: true,
    };
  },
  addAttributes() {
    return {
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      style: {
        default: 'height: auto; cursor: pointer;',
      },
    };
  },
  addNodeView() {
    return ({ node, editor, getPos }) => {
      const {
        view,
        options: { editable },
      } = editor;
      const { src, alt, style } = node.attrs;
      const $container = document.createElement('div');
      const $img = document.createElement('img');

      $container.appendChild($img);
      $img.setAttribute('src', src);
      $img.setAttribute('alt', alt);
      $img.setAttribute('style', style);
      $img.setAttribute('draggable', 'true');

      if (!editable) {
        return { dom: $img };
      }

      const dotsPosition = [
        {
          class: 'top-left',
          style: 'top: -8px; left: -8px; cursor: nwse-resize;',
          // Indicate that this handle affects the left side of the image
          direction: 'left',
        },
        {
          class: 'top-right',
          style: 'top: -8px; right: -8px; cursor: nesw-resize;',
          // Indicate that this handle affects the right side of the image
          direction: 'right',
        },
        {
          class: 'bottom-left',
          style: 'bottom: -8px; left: -8px; cursor: nesw-resize;',
          // Indicate that this handle affects the left side of the image
          direction: 'left',
        },
        {
          class: 'bottom-right',
          style: 'bottom: -8px; right: -8px; cursor: nwse-resize;',
          // Indicate that this handle affects the right side of the image
          direction: 'right',
        },
      ];

      let isResizing = false;
      let startX, startWidth;
      let resizeDirection = ''; // To store 'left' or 'right'

      const updateContainerPosition = () => {
        const rect = $img.getBoundingClientRect();
        $container.style.position = 'relative';
        $container.style.display = 'inline-block';
        $container.style.width = `${rect.width + 6}px`;
        $container.style.height = `${rect.height + 6}px`;
      };

      $container.addEventListener('click', () => {
        updateContainerPosition();
        $container.style.border = '3px solid #1698f1';
        $container.style.cursor = 'pointer';

        Array.from({ length: 4 }, (_, index) => {
          const $dot = document.createElement('div');
          const dotInfo = dotsPosition[index]; // Get the dot's info including direction

          const dotStyle = `
            position: absolute;
            width: 12px;
            height: 12px;
            border: 3px solid #1698f1;
            border-radius: 50%;
            background-color:rgb(255, 255, 255);
            z-index: 1000;
            ${dotInfo.style}
          `;

          $dot.setAttribute('style', dotStyle);
          $dot.classList.add(`resize-dot-${dotInfo.class}`);

          $dot.addEventListener('mousedown', (e) => {
            e.preventDefault();
            e.stopPropagation();
            isResizing = true;
            startX = e.clientX;
            startWidth = $img.offsetWidth;
            resizeDirection = dotInfo.direction; // Set the resize direction
            const naturalRatio = $img.naturalWidth / $img.naturalHeight;

            const onMouseMove = (e) => {
              if (!isResizing) return;

              // Calculate deltaX based on the direction of resize
              let currentDeltaX;
              if (resizeDirection === 'left') {
                currentDeltaX = startX - e.clientX; // Standard calculation for left resize
              } else {
                // resizeDirection === 'right'
                currentDeltaX = e.clientX - startX; // Invert deltaX for right resize
              }

              const velocityMultiplier = 1.5;

              const newWidth = startWidth + currentDeltaX * velocityMultiplier;
              const minSize = 50;
              const finalWidth = Math.max(minSize, newWidth);
              const finalHeight = finalWidth / naturalRatio;

              $img.style.width = `${finalWidth}px`;
              $img.style.height = `${finalHeight}px`;

              updateContainerPosition();
            };

            const onMouseUp = () => {
              if (isResizing) {
                isResizing = false;
                if (typeof getPos === 'function') {
                  const newAttrs = {
                    ...node.attrs,
                    style: $img.style.cssText,
                  };
                  view.dispatch(
                    view.state.tr.setNodeMarkup(
                      getPos(),
                      null,
                      newAttrs,
                      node?.marks
                    )
                  );
                }
              }

              document.removeEventListener('mousemove', onMouseMove);
              document.removeEventListener('mouseup', onMouseUp);
            };

            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
          });

          $container.appendChild($dot);
          return $dot;
        });
      });

      const cleanupContainer = () => {
        $container.style.border = 'none';
        const dots = $container.querySelectorAll('[class^="resize-dot-"]');
        dots.forEach((dot) => dot.remove());
      };

      document.addEventListener('click', (e) => {
        if (!$container.contains(e.target)) {
          cleanupContainer();
        }
      });

      return {
        dom: $container,
      };
    };
  },
});
